<template>
  <div class="privacy-policy">
    <div class="policy-container">
      <header class="policy-header">
        <h1>中碳碳盘查Agent用户协议及隐私说明</h1>
        <div class="policy-dates">
          <time>更新日期：2025年11月14日</time>
          <time>生效日期：2025年11月14日</time>
        </div>
      </header>

      <main class="policy-content">
        <!-- 各章节使用section包装 -->
        <section id="overview" class="policy-section">
          <h2>协议概述</h2>
          <p>
            欢迎您使用中碳碳盘查Agent产品及/或服务！我们将严格遵守法律法规要求采取相应的安全保护措施，致力于确保用户信息及隐私的安全性。
          </p>
          <p>
            在使用本平台及服务前，请阅读并遵守本协议。请您务必审慎阅读、充分理解各条款内容，特别是限制或免除责任的条款，并选择接受或不接受本协议。本协议可由开发者随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在平台中查阅最新版协议条款。
          </p>
          <p class="bold-text">
            如果您无法准确理解或不同意本协议的任一内容，请暂时不要使用本服务。当您通过网络页面点击确认、勾选等方式同意本协议或实际使用本服务时，均表示您与我们已就本协议达成一致，同意受本协议约束。您同意本政策表示您已了解我们提供的产品及/或服务，以及相应产品及/或服务功能运行所需的必要用户信息（请特别注意，本政策所述用户信息可能包含企业/个人信息及/或敏感企业/个人信息，以下不再赘述），并给予相应的收集使用授权。
          </p>
          <p class="bold-text">
            如您未满18周岁，请在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用本服务。
          </p>
          <p>
            如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。
          </p>
        </section>

        <section id="service" class="policy-section">
          <h2>一、服务内容</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>1.1 服务对象</h3>
              <div class="content-box">
                <p>
                  本服务主要面向的对象是具备完全民事行为能力的成年人。基于本服务的特点，本服务需要用户对内容进行有效识别和合理应用。<span
                    class="bold-text"
                    >如果您是未成年人或不具备使用本服务的民事行为能力，请务必在监护人的同意和指导下使用本服务。</span
                  >
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.2 基本服务</h3>
              <div class="content-box">
                <p>
                  我们以大模型为基础，向用户提供各项人工智能服务。模型基于用户输入信息（以下称"输入"），通过计算推理等输出相应的内容作为响应（以下称"输出"、"生成内容"）。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.3 基本的服务功能</h3>
              <div class="content-box">
                <ul class="feature-list">
                  <li>
                    我们的产品和服务的正常使用依赖于您输入的内容，因此我们需要收集并使用<span
                      class="bold-text"
                      >您输入的文字、语音、图片或其他格式的文件，</span
                    >从而为您提供对话服务。
                  </li>
                  <li>
                    当您从系统剪贴板粘贴内容至对话输入框时，我们需要收集并使用您的<span
                      class="bold-text"
                      >剪贴板信息。</span
                    >
                  </li>
                  <li>
                    为实现并保证体验的连续性，我们需要收集并使用<span
                      class="bold-text"
                      >历史对话信息。</span
                    >
                  </li>
                </ul>
                <p>您可以删除您的历史对话信息。</p>
                <p>
                  您上传任何内容（包括但不限于正常输入、反馈或联系我们时提供的文字、语音、图片或其他格式的文件）时，请特别留意这些内容是否<span
                    class="bold-text"
                    >包含或涉及任何第三方的个人/企业信息或者涉密信息等不适当的信息。</span
                  >这包括但不限于姓名、联系方式或其他个人识别信息。在提交此类信息前，<span
                    class="bold-text"
                    >您有责任确保已经获得了所有必要的合法授权，以避免无意中泄露他人隐私或者侵犯其合法权益。</span
                  >
                </p>
                <div class="sub-section">
                  <h4>
                    希望您理解，根据个人信息保护法的规定，下列情形<span
                      class="bold-text"
                      >无需事先获得您的同意：</span
                    >
                  </h4>
                  <div class="content-box">
                    <ol class="feature-list">
                      <li>
                        1)
                        <span class="bold-text">为订立、履行合同所必需：</span
                        >当您与我们订立或履行合同时，可能需要处理您的个人信息，例如为了完成交易或提供服务。
                      </li>
                      <li>
                        2)
                        <span class="bold-text"
                          >为履行法定职责或者法定义务所必需：</span
                        >当我们需要遵守法律法规，履行法定职责或义务时，可能需要处理您的个人信息，例如与国家安全、刑事侦查、审判和执行等有关的或响应政府部门指示所必需。
                      </li>
                      <li>
                        3)
                        <span class="bold-text"
                          >为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需：</span
                        >在紧急情况下，为了保护您或他人的生命、健康和财产安全，可能需要处理您的个人信息。
                      </li>
                      <li>
                        4)
                        <span class="bold-text"
                          >为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息：</span
                        >为了公共利益，如新闻报道和舆论监督，可能在合理范围内处理您的个人信息。
                      </li>
                      <li>
                        5)
                        <span class="bold-text"
                          >在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息：</span
                        >如果您已经公开了某些个人信息，或者这些信息已经合法公开，我们可能在合理范围内处理这些信息。
                      </li>
                      <li>
                        6)
                        <span class="bold-text"
                          >法律、行政法规规定的其他情形：</span
                        >其他法律法规规定的情形。
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.4 信息收集</h3>
              <div class="content-box">
                <p>我们会按照以下两种方式收集您的个人信息：</p>
                <div class="sub-section">
                  <h4>您主动提供：</h4>
                  <div class="content-box">
                    <ul class="feature-list">
                      <li>
                        当您使用产品和服务时，您可能需要提供一些基本信息，如电话号码、电子邮件等。
                      </li>
                      <li>
                        在使用过程中，您可能会主动上传文字、图片、音频、视频或其他文件等内容。
                      </li>
                      <li>
                        当您向我们反馈问题、提出建议、投诉或请求客服支持时，您可能会提供相关的个人信息。
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="sub-section">
                  <h4>我们主动收集：</h4>
                  <div class="content-box">
                    <ul class="feature-list">
                      <li>
                        服务器会自动记录您的使用情况，包括访问时间、IP地址等。
                      </li>
                      <li>
                        我们可能会使用Cookie和类似技术来了解您的使用习惯，以便提供更个性化的服务。
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.5 信息保护</h3>
              <div class="content-box">
                <p>
                  中碳非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取合理可行的措施，尽力避免收集无关的用户信息。<span
                    class="bold-text"
                    >尽管我们已经按照相关法律法规要求采取了合理有效的安全措施，但由于技术限制和可能存在的恶意手段，我们不能保证百分之百的信息安全。请您了解并理解，我们所提供的系统和通信网络可能会受到我们无法控制的因素影响而出现问题。</span
                  >
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>1.6 风险提示</h3>
              <div class="content-box">
                <p>
                  人工智能和机器学习是快速发展的研究领域。我们一直在努力改进我们的服务，使其更加准确、可靠、安全和有益。然而，<span
                    class="bold-text"
                    >鉴于机器学习的不确定性和概率性，使用我们的服务在某些情况下可能会产生不准确的输出结果，亦无法保证输出的时效性。</span
                  >此外，受限于技术，<span class="bold-text"
                    >我们的输出也可能无法穷尽展示您想要的内容。</span
                  >
                </p>
                <div class="sub-section">
                  <h4>因此，请您在使用服务时注意：</h4>
                  <div class="content-box">
                    <ol class="feature-list bold-text">
                      <li>
                        1)
                        请不要将输出视为唯一的事实来源或绝对真实信息，您需要自行评估内容的准确性和适用性。根据使用目的和场景，合理应用或分享，避免因错误或不适当的内容带来不良影响；
                      </li>
                      <li>
                        2)
                        输出不可以用来替代医疗、法律、金融、教育等领域的专业建议；
                      </li>
                      <li>
                        3)
                        不要直接使用生成内容作出可能对个人产生法律影响或其他重大影响的决定，例如关于个人的信用、教育、就业、住房、保险、法律、医疗或其他重要决策；
                      </li>
                      <li>
                        4)
                        输出不代表中碳的观点，仅供您参考，如果输出提及任何第三方产品或服务，这并不意味着该第三方认可该内容，或该第三方与中碳有关联。
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section id="account" class="policy-section">
          <h2>二、账号使用说明</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>2.1 注册</h3>
              <div class="content-box">
                <p>
                  您在使用本服务前，可通过中碳普惠云科技有限公司的官方联系方式申请账号，按要求填写真实、准确、合法、有效的相关信息，并确认同意本协议以及其他相关规则、政策。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>2.2 使用及转让</h3>
              <div class="content-box">
                <p>
                  注册成功后，您本人对您的账号享有合法使用权并对您账号项下的所有行为承担法律责任。您应妥善保管账号，不得以任何形式将账号擅自转让、出借、出租或提供给他人使用。
                </p>
                <p>
                  如因您未保管好账号，包括账号被盗窃或非法利用后未及时采取补救措施，所导致的损失，您应自行负责。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>2.3 注销</h3>
              <div class="content-box">
                <p>
                  您有权注销您的账号。但您注销账号后，我们仍需按照网络安全法等法律法规的要求，保留您相应的注册数据及行为记录。如您在注销前使用本服务过程中存在违法或违反本协议的行为，我们仍有权行使本协议所约定的权利。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="rights" class="policy-section">
          <h2>三、权利与义务</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>3.1 您的权利与义务</h3>
              <div class="content-box">
                <p>
                  您有权依据本协议的约定使用本服务，有权进行反馈和投诉。您使用本服务应遵守法律、法规以及本协议，也应遵守我们在本服务相关页面公布的其他相关规则、政策。您不得利用本服务进行违法、违规以及其他可能危害国家安全、社会公共利益、侵犯他人合法权益、扰乱平台经营秩序的行为。您不得转让本条款下的任何权利或义务，任何此类尝试均无效。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>3.2 我们的权利与义务</h3>
              <div class="content-box">
                <p>
                  我们将依法依规为您提供服务，积极履行法定义务，保护网络安全、数据安全和您的个人信息，保护未成年人的合法利益和身心健康，尽力在现有技术上维护本服务安全、稳定、持续的运行，努力提升和改进技术，保障您的服务使用体验。<span
                    class="bold-text"
                    >但由于技术和资源限制，我们无法保证本服务始终能及时响应您的需求，请您理解。</span
                  >
                </p>
                <p class="bold-text">
                  如果您存在违反法律、法规、本协议约定或平台规则的行为，我们有权采取相应措施，包括但不限于通知您整改、屏蔽删除您的内容，冻结、关闭、转移您的账号，拒绝、暂停或停止向您提供服务等。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="rules" class="policy-section">
          <h2>四、用户使用规范</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>4.1 您向本服务提交输入时，应当：</h3>
              <div class="content-box">
                <ol class="feature-list">
                  <li>
                    1)
                    保证这些输入不属于任何国家秘密或其他可能会对国家安全或者公共利益造成不利影响的数据，不侵犯任何人的知识产权、肖像权、名誉权、荣誉权、姓名权、隐私权、个人信息权益等合法权利/权益；
                  </li>
                  <li>
                    2)
                    若您的输入中涉及个人信息，请您确保您已经取得相关个人信息主体的知情同意（涉及敏感个人信息的，应获得单独同意），或采取了符合法律要求的匿名化处理措施，否则请勿上传至本平台；不要在任何情况下输入不满十四周岁的未成年人的敏感个人信息；
                  </li>
                  <li>
                    3)
                    若您的输入中涉及商业信息（尤其涉及商业秘密），请您确保您有权处理相应的商业信息，同时，请在上传前进行必要的脱敏处理，避免产生不利的商业影响。
                  </li>
                </ol>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                4.2
                您不得将本服务用于任何违反法律法规，侵犯公共利益、我们或第三方合法权益的非法及不当目的：
              </h3>
              <div class="content-box">
                <ol class="feature-list">
                  <li>
                    1)
                    用于可能对人身健康、心理、社会或经济等产生严重有害影响或违反科技伦理的危险目的；
                  </li>
                  <li>
                    2)
                    用于从事侵犯知识产权、商业秘密以及其他违反商业道德的行为；
                  </li>
                  <li>
                    3)
                    用于利用算法、数据、平台等优势，实施垄断和不正当竞争行为；
                  </li>
                  <li>4) 用于从事诈骗、欺诈、误导或欺骗性活动；</li>
                  <li>
                    5)
                    用于侵犯隐私或合法个人信息权益，例如非法收集或披露个人身份信息或教育、财务或其他受保护的记录，包括但不限于地址、电话号码、电子邮件地址、个人身份证件中的号码和特征（例如身份证号、社保账号、护照号码）或信用卡号码；
                  </li>
                  <li>
                    6)
                    用于其他法律法规所禁止、限制的，或可能损害公共利益、我们或第三方合法利益的使用方式。
                  </li>
                </ol>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                4.3 您不得利用本服务制作、复制、发布含有下列内容的违法信息：
              </h3>
              <div class="content-box">
                <ol class="feature-list">
                  <li>1) 反对宪法所确定的基本原则的；</li>
                  <li>
                    2)
                    危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                  </li>
                  <li>3) 损害国家荣誉和利益的；</li>
                  <li>
                    4)
                    歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
                  </li>
                  <li>
                    5)
                    宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
                  </li>
                  <li>6) 煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                  <li>7) 破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                  <li>8) 散布谣言，扰乱经济秩序和社会秩序的；</li>
                  <li>
                    9) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                  </li>
                  <li>
                    10) 侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
                  </li>
                  <li>11) 法律、行政法规禁止的其他内容。</li>
                </ol>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                4.4 您不得利用本服务制作、复制、发布含有下列内容的不良信息：
              </h3>
              <div class="content-box">
                <ol class="feature-list">
                  <li>1) 使用夸张标题，内容与标题严重不符的；</li>
                  <li>2) 炒作绯闻、丑闻、劣迹等的；</li>
                  <li>3) 不当评述自然灾害、重大事故等灾难的；</li>
                  <li>4) 带有性暗示、性挑逗等易使人产生性联想的；</li>
                  <li>5) 展现血腥、惊悚、残忍等致人身心不适的；</li>
                  <li>6) 煽动人群歧视、地域歧视等的；</li>
                  <li>7) 宣扬低俗、庸俗、媚俗内容的；</li>
                  <li>
                    8)
                    可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的；
                  </li>
                  <li>9) 其他对网络生态造成不良影响的内容。</li>
                </ol>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                4.5 您不得从事以下危害网络安全、本服务运营安全及经营秩序的活动：
              </h3>
              <div class="content-box">
                <ol class="feature-list">
                  <li>
                    1)
                    非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动，例如：使用未经许可的数据或进入未经许可的服务器/账号；伪造TCP/IP数据包名称或部分名称；未经许可，企图探查、扫描、测试本服务系统或网络的弱点或其它实施破坏网络安全；未经允许进入网络或者计算机系统并删除、修改、增加存储信息；企图干涉、破坏本服务系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的；
                  </li>
                  <li>
                    2)
                    提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；
                  </li>
                  <li>
                    3)
                    明知他人从事危害网络安全的活动，为其提供技术支持、广告推广、支付结算等帮助；
                  </li>
                  <li>
                    4)
                    对本服务进行反向工程、反向汇编、反向编译、翻译或者以其他方式尝试发现本服务的源代码、模型、算法和系统的源代码或底层组件；
                  </li>
                  <li>
                    5)
                    通过编写或使用任何自动化脚本、程序、工具（包括但不限于机器人、爬虫、定时任务等）来模拟人工操作，以实现自动、批量使用我们的产品或服务；
                  </li>
                  <li>
                    6)
                    重复、大量地进行相同或相似操作，高频提交相同或相似内容等，干扰服务的正常运行和秩序；
                  </li>
                  <li>
                    7)
                    未经我们授权，利用本服务来开发、服务与本服务有竞争可能性的应用程序、产品、服务或模型；
                  </li>
                  <li>
                    8)
                    未经我们授权，将本服务的全部或部分进行复制、转让、出租、出借、出售或提供分许可、转许可；
                  </li>
                  <li>9) 其他危害网络安全、本服务运营安全及经营秩序的行为。</li>
                </ol>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                4.6
                您不得通过以下方式恶意对抗本服务的信息内容安全管理和风险防范机制，包括但不限于：
              </h3>
              <div class="content-box">
                <ol class="feature-list">
                  <li>
                    1)
                    恶意对抗行为，包括但不限于使用变体、乱码、字符、谐音等方式规避服务检测来输入或生成违法言论；
                  </li>
                  <li>
                    2)
                    通过假扮身份、反向诱导、越狱攻击等方式进行恶意攻击、诱导和投毒；
                  </li>
                  <li>
                    3)
                    删除、篡改或隐匿我们已标注的人工智能生成内容的标识（包括存在于生成内容上肉眼可见的显著标识以及通过特定技术手段植入生成内容元文件的隐蔽标识）；
                  </li>
                  <li>
                    4)
                    其他恶意对抗本服务的信息内容安全管理和风险防范机制的行为。
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section id="copyright" class="policy-section">
          <h2>五、知识产权与其他权利</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>
                5.1
                除了依照法律规定应享有权利的相关权利人外，中碳对本服务（包括但不限于软件、技术、程序、代码、模型权重、用户界面、网页、文字、图表、版面设计、商标、电子文档）享有法律法规允许范围内的全部权利（包括但不限于著作权、商标权、专利权等知识产权和其他权利）。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                5.2
                在未侵害他人合法知识产权或其他权利并遵守本协议的前提下，您在法律允许的范围内，拥有对您输入和输出内容的知识产权、其他权利和对内容负责的义务。由于技术限制，我们无法保证其他用户的内容与您的内容完全不一致，不排除会出现输出内容雷同的情况，鉴于此，您对输出所享有的权利无法当然及于其他用户的内容。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                5.3
                为了提升您使用本服务的体验，您授予我们一项免费的的使用权，以在法律允许的范围内将您输入输出之内容及反馈用于模型服务优化。
              </h3>
            </div>
          </div>
        </section>
        <section id="liability" class="policy-section">
          <h2>六、违约责任</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>
                6.1
                您了解并同意，针对您违反本协议及相关法律法规的行为，我们可以独立判断，包括依据您的个人信息与行为数据或其他互动关系来综合认定，在无需通知的情况下，对您采取包括但不限于警示提醒、限期改正、限制账号功能、暂停使用、关闭账号、禁止重新注册、删除相关内容等处置措施。
                我们有权公告处理结果，且有权根据实际情况决定是否恢复使用。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                6.2
                您应当独立承担因您的违约行为导致的全部法律责任或第三方主张的任何索赔和要求。因此给我们造成任何损失的，您应当予以全部赔偿（包括我们维权所支出的诉讼费、仲裁费、律师费、公证费、公告费、鉴定费、差旅费、调查取证费、赔偿金、违约金、和解费用、行政处罚的罚金等）。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                6.3
                为了提升您使用本服务的体验，您授予我们一项免费的的使用权，以在法律允许的范围内将您输入输出之内容及反馈用于模型服务优化。
              </h3>
            </div>
          </div>
        </section>
        <section id="liability2" class="policy-section">
          <h2>七、责任限制</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>7.1 不可抗力等原因：</h3>
              <div class="content-box">
                <div class="sub-section">
                  <h4>
                    我们依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们不承担相应的责任：
                  </h4>
                  <div class="content-box">
                    <ol class="feature-list">
                      <li>
                        1)
                        因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
                      </li>
                      <li>
                        2)
                        因电力供应故障、通讯网络故障等公共服务因素或移动通讯终端病毒或黑客攻击、系统不稳定等第三人因素；
                      </li>
                      <li>
                        3)
                        在已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <h3>7.2 技术限制：</h3>
              <div class="content-box">
                <div class="sub-section">
                  <h4>
                    由于本服务所依赖的技术和资源瓶颈，我们不对以下事项作出任何保证：
                  </h4>
                  <div class="content-box">
                    <ol class="feature-list bold-text">
                      <li>1) 不保证本服务符合您的实际或特定需求；</li>
                      <li>
                        2)
                        不保证本服务准确可靠、功能可用、及时、无错误、不受干扰、无中断、持续稳定、不存在任何故障；
                      </li>
                      <li>
                        3)
                        不保证本服务中的全部信息无瑕疵、无偏见、不侵权、完全合理；
                      </li>
                      <li>
                        4)
                        不保证本服务的代码、程序及其指向的内容的准确性、稳定性和完整性；
                      </li>
                      <li>
                        5)不保证通过恶意诱导或其他违反本协议的使用方式所输出的内容与本服务运营主体的观点保持一致。
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                7.3
                若您遇到涉及借款、投融资、理财等财产相关的信息，以及账号密码或广告等内容，请您务必保持警惕并自行判断。对于您因上述情况遭受的任何损失，包括但不限于利润损失、商业信誉受损、资料丢失或其他有形或无形损失，我们不承担任何直接、间接、附带、衍生性或惩罚性的赔偿责任。除非法律法规另有明确规定，否则我们对您承担的全部责任，无论基于何种原因或方式，均不会超过您在使用本服务期间支付给我们的费用总额（如有）。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                7.4
                我们有权根据本协议处理违法违规内容，但该权利并不构成我们的义务或承诺。我们无法保证能够及时发现或处理所有违法行为。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                7.5
                我们保留将本条款下的权利或义务转让给任何关联公司、子公司或与本服务相关的任何业务继受者的权利。
              </h3>
            </div>
          </div>
        </section>
        <section id="termination" class="policy-section">
          <h2>八、服务终止</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>
                8.1
                用户有权随时按照注销流程终止本服务。如果用户出现违反法律法规，违反本协议或平台规则，侵害公众、我们或者第三人合法权益的情况，我们会视情况终止服务。
              </h3>
            </div>
            <div class="sub-section">
              <h3>
                8.2
                为了整体服务运营的需要，我们有权视具体情况决定服务/功能设置、范围，修改、中断、中止或终止本服务。
              </h3>
            </div>
          </div>
        </section>
        <section id="minors" class="policy-section">
          <h2>九、未成年人使用提示</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>
                9.1
                未成年人应该在其监护人的监督指导下使用本服务，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好的上网习惯。
              </h3>
            </div>
            <div class="sub-section">
              <h3>9.2 未成年用户应当遵守《全国青少年网络文明公约》：</h3>
              <div class="content-box">
                <ul class="feature-list">
                  <li>要善于网上学习，不浏览不良信息；</li>
                  <li>要诚实友好交流，不侮辱欺诈他人；</li>
                  <li>要增强自护意识，不随意约会网友；</li>
                  <li>要维护网络安全，不破坏网络秩序；</li>
                  <li>要有益身心健康，不沉溺虚拟时空。</li>
                </ul>
              </div>
            </div>
            <div class="sub-section">
              <h3>
                9.3
                为更好的保护未成年人的隐私权益，请您务必严格遵守相关法律法规和用户使用规范，慎重上传包含未成年人信息或素材的内容，一经上传，即视为您同意我们在本服务中依法依约处理与该未成年人相关的内容。
              </h3>
            </div>
          </div>
        </section>
        <section id="law" class="policy-section">
          <h2>十、法律适用与争议解决</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>
                10.1
                本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律。
              </h3>
            </div>
          </div>
          <div class="section-content">
            <div class="sub-section">
              <h3>
                10.2
                若本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向中碳普惠云科技有限公司住所地有管辖权的法院起诉。
              </h3>
            </div>
          </div>
        </section>
        <section id="others" class="policy-section">
          <h2>十一、其他说明</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3>11.1 条款的可分性与可执行性：</h3>
              <div class="content-box">
                <p>
                  若本协议中任何一条款被认定为废止、无效或不可执行，该条款应被视为可分割的，不影响本协议其他条款的有效性及可执行性。此外，我们延迟或暂不行使本协议项下的任何权利，并不应被视为对该权利的放弃。
                </p>
              </div>
            </div>
            <div class="sub-section">
              <h3>11.2 本协议的更新：</h3>
              <div class="content-box">
                <p class="bold-text">
                  为持续优化服务体验并适应国家法律法规、政策调整、技术条件及产品功能等变化，我们可能会不定期地更新本协议。更新后的协议内容将构成本协议的组成部分，并通过页面公示、页面提示或信息推送等方式通知您。如您继续使用本服务，即表示您已同意接受更新后的本协议内容。如您对更新后的协议条款存有异议的，您有权停止登录或使用本服务。若您继续登录或使用本服务，即视为您认可并接受修改后的协议条款。
                </p>
              </div>
            </div>
          </div>
        </section>
        <section id="contact" class="policy-section">
          <h2>十二、联系我们</h2>
          <div class="section-content">
            <div class="sub-section">
              <h3></h3>
              <div class="content-box">
                <p>
                  如果您发现您的账号存在任何问题，请随时与我们联系。您可以通过发送邮件至customerservice@carbonneutrality-group.com与我们取得联系。
                </p>
                <p>
                  如果您发现本服务或其生成的内容存在违法违规行为、违法不良信息，或侵犯了您的合法权益（包括但不限于知识产权、个人信息、肖像权、名誉权等），请随时与我们联系进行举报或投诉。
                </p>
                <p>
                  当您的合法权益受到侵害，投诉时需要按照法律规定提交您的真实身份信息以及构成侵权的初步证据。您可以通过发送邮件至customerservice@carbonneutrality-group.com与我们取得联系。我们会按照法律的规定，尽快处理您的请求。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer class="footer">
        <div class="bold-text">
          本“协议”由中碳普惠云科技有限公司所有，保留一切对此“协议”解释的权利。
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style scoped>
.privacy-policy {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px;
  font-size: 18px;
  color: #404040;
}

/* 导航样式 */
.policy-nav {
  position: sticky;
  top: 32px;
  align-self: start;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 8px;
}

.policy-nav ul {
  list-style: none;
  padding: 0;
}

.policy-nav a {
  display: block;
  padding: 8px;
  color: #333;
  text-decoration: none;
  transition: color 0.2s;
}

.policy-nav a:hover {
  color: #1890ff;
}

/* 内容区样式 */
.policy-container {
  min-width: 0;
  width: 100%;
}

.policy-header {
  margin: 48px 0;
  text-align: center;
}

h1 {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.policy-dates {
  color: #666;
  display: flex;
  gap: 16px;
  justify-content: center;
}

/* 章节样式 */
.policy-section {
  padding: 0 16px;
}
.policy-section h2 {
  position: relative;
  /* padding-left: 16px; */
}

.policy-section .section-content {
  margin-top: 24px;
}

.sub-section {
  margin-bottom: 20px;
}

.content-box {
  padding: 8px 0;
}

.notice-box {
  background: #fff7e6;
  border-left: 4px solid #ffa940;
  padding: 16px;
  margin: 16px 0;
}

.feature-list {
  margin: 16px 0;
}
.feature-list li {
  padding-left: 24px;
  margin: 8px 0;
}

.footer {
  text-align: center;
  margin: 16px;
}

h2 {
  font-size: 24px;
  font-weight: 500;
  color: #1a1a1a;
  margin: 20px 0 10px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

h3 {
  font-size: 20px;
  font-weight: 500;
  color: #262626;
  margin: 20px 0 10px;
}

h4 {
  color: #262626;
}

p {
  margin: 10px 0;
  line-height: 1.8;
}
.bold-text {
  color: #111;
}

/* 响应式布局 */
/* @media (max-width: 768px) {
  .privacy-policy {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .policy-nav {
    display: none;
  }
} */
</style>